import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { LayoutModule } from './layout/layout.module';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { AreaClienteModule } from './area-cliente/area-cliente.module';
import { AngularBaseUiModule } from './angular-base-ui/angular-base-ui.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    LayoutModule,
    routing,
    AngularBaseUiModule,
    AreaClienteModule
    ],
  exports: [AppComponent],
  bootstrap: [AppComponent],
  providers: [ ]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/app.module.ts